import { useQuery, gql } from '@apollo/client';

export function GetDataPointsByModuleCapture() {
  const { data = {}, loading, error } = useQuery(GET_DATAPOINTBYCUSTOMER);
  return { loading, data: data.DataPointsByModuleCapture || [], error };
}

const GET_DATAPOINTBYCUSTOMER = gql`
  query DataPointsByModuleCapture {
    DataPointsByModuleCapture {
      _id
      name
      customerId
      longitude
      latitude
      active
      module
      location
      time
      diameter
      threshold
      yValuesMax
      setting
    }
  }
`;
